import { useEffect, useState } from 'react'

import { useTranslation, TFunction } from 'react-i18next'

import DateHelper from 'common/helpers/date'

const ONE_SECOND = 1000

const formatCountdownMessage = (date: string, zoneId: string, t: TFunction) => {
  const formatDate
    = DateHelper.convertDateToLocalizedFormat(date, zoneId)
  const liveStartAt = new Date(formatDate)
  const remainingMs = DateHelper.diff(new Date(), liveStartAt)
  const remainingSeconds = Math.round(remainingMs / 1000)
  const [hours, minutes, seconds] = DateHelper.calculateTimeFields(remainingMs)

  if (hours >= 1) {
    return t('player_countdown.countdown_message_formatted', {
      inRemainingTime: DateHelper.getRemainingTime(date)
    })
  }

  if (remainingSeconds <= 0) {
    return '00:00'
  }

  return `${DateHelper.padNumber(minutes)}:${DateHelper.padNumber(seconds)}`
}

const usePlayerCountdown = (startAt: string, zoneId: string) => {
  const { t } = useTranslation()

  const [countdownMessage, setCountdownMessage] = useState<string>()
  const [formattedDate, setFormattedDate] = useState<string>()

  useEffect(
    () => {
      setCountdownMessage(formatCountdownMessage(startAt, zoneId, t))
      setFormattedDate(
        DateHelper.convertISODateToLocaleFormatted(startAt, zoneId)
      )
    },
    [startAt, zoneId, t]
  )

  useEffect(
    () => {
      const id = global.setInterval(
        () => {
          setCountdownMessage(formatCountdownMessage(startAt, zoneId, t))
        },
        ONE_SECOND
      )

      return () => {
        global.clearInterval(id)
      }
    },
    [startAt, zoneId, t]
  )

  return { countdownMessage, formattedDate }
}

export default usePlayerCountdown
